<template>
  <div class="article-form">
    <el-form :model="form" label-width="90px" class="form">
      <el-form-item label="分类">
        <el-select v-model="form.category_id" placeholder="选择分类" style="width:100%">
          <el-option v-for="c in categories" :key="c.id" :label="c.name" :value="c.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="标题">
        <el-input v-model="form.title" />
      </el-form-item>
      <el-form-item label="别名">
        <el-input v-model="form.slug" />
      </el-form-item>
      <el-form-item label="摘要">
        <el-input v-model="form.summary" type="textarea" />
      </el-form-item>
      <el-form-item label="内容">
        <div style="border: 1px solid #ccc; width:100%">
          <Toolbar
            :editor="editorRef"
            :default-config="toolbarConfig"
            style="border-bottom: 1px solid #ccc" />
          <Editor
            v-model="form.content"
            :default-config="editorConfig"
            @onCreated="handleCreated"
            style="height:400px;overflow-y:hidden" />
        </div>
      </el-form-item>
      <el-form-item label="缩略图">
        <el-input v-model="form.thumbnail" />
      </el-form-item>
      <el-form-item label="作者">
        <el-input v-model="form.author" />
      </el-form-item>
      <el-form-item label="发布时间">
        <el-date-picker v-model="form.published_at" type="date" value-format="x" style="width:100%" />
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="form.status">
          <el-option :value="1" label="启用" />
          <el-option :value="0" label="禁用" />
        </el-select>
      </el-form-item>
      <el-form-item label="VIP专享">
        <el-switch v-model="form.is_vip" :active-value="1" :inactive-value="0" />
      </el-form-item>
      <el-form-item>
        <el-button @click="goBack">返回</el-button>
        <el-button type="primary" :loading="loading" @click="submitForm">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script setup>
import { ref, shallowRef, onMounted, onBeforeUnmount } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import request from '../../utils/request'
import store from '../../store'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'

const route = useRoute()
const router = useRouter()
const loading = ref(false)
const categories = ref([])
const editorRef = shallowRef()

const toolbarConfig = {}

const editorConfig = {
  placeholder: '请输入内容...',
  MENU_CONF: {
    uploadImage: {
      async customUpload(file, insertFn) {
        const fd = new FormData()
        fd.append('file', file)
        try {
          const res = await request.post('/v1/upload/image', fd, {
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          if (res && res.url) {
            insertFn(res.url)
          } else {
            ElMessage.error('上传失败')
          }
        } catch (err) {
          ElMessage.error('上传失败')
        }
      }
    },
    uploadAttachment: {
      async customUpload(file, insertFn) {
        const fd = new FormData()
        fd.append('file', file)
        try {
          const res = await request.post('/v1/upload/file', fd, {
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          if (res && res.url) {
            insertFn(res.url, { text: file.name })
          } else {
            ElMessage.error('上传失败')
          }
        } catch (err) {
          ElMessage.error('上传失败')
        }
      }
    }
  }
}

const form = ref({
  id: null,
  category_id: null,
  title: '',
  slug: '',
  content: '',
  summary: '',
  thumbnail: '',
  status: 1,
  is_vip: 0,
  author: '',
  published_at: ''
})

const loadCategories = async () => {
  categories.value = await request.get('/v1/article-category/list')
}

const handleCreated = (editor) => {
  editorRef.value = editor
}

const loadDetail = async (id) => {
  const data = await request.get('/v1/article/view', { params: { id } })
  Object.assign(form.value, data)
}

const submitForm = async () => {
  loading.value = true
  try {
    if (form.value.id) {
      await request.post('/v1/article/update', { ...form.value })
      ElMessage.success('更新成功')
    } else {
      await request.post('/v1/article/create', { ...form.value })
      ElMessage.success('创建成功')
    }
    router.push('/article/list')
  } catch (e) {
    ElMessage.error(e.toString())
  } finally {
    loading.value = false
  }
}

const goBack = () => {
  router.push('/article/list')
}

onMounted(() => {
  const id = route.params.id
  if (store.state.token) {
    loadCategories()
    if (id) loadDetail(id)
  } else {
    // wait for token
  }
})

onBeforeUnmount(() => {
  const editor = editorRef.value
  if (editor) editor.destroy()
})
</script>

<style scoped>
.article-form {
  padding: 20px;
}
.form :deep(textarea) { min-height: 80px; }
</style>

